import { useGetResidentStatusFlagsQuery } from "app/services/api/residentsApi";
import { useEffect, useState, useRef } from "react";

export const useResidentStatusFlags = (residentId: number) => {
  const [matchedFlagIds, setMatchedFlagIds] = useState<number[]>([]);
  const isInitializedRef = useRef(false);

  const { data: residentFlagsData, isLoading } = useGetResidentStatusFlagsQuery(
    { residentId },
    { skip: !residentId },
  );

  useEffect(() => {
    if (residentFlagsData && !isInitializedRef.current) {
      const initialFlagIds = residentFlagsData.map((flag) => flag.id);
      setMatchedFlagIds(initialFlagIds);
      isInitializedRef.current = true;
    }
  }, [residentFlagsData]);

  return {
    matchedFlagIds,
    setMatchedFlagIds,
    isLoading,
  };
};
